import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const ApplicationService = {};

ApplicationService.createApplication = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/Applications",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default ApplicationService;